import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DiagnosticsService } from '@rocksoft/appmanagement-sdk';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { LatestDeviceDiagnosticsActions, LatestDeviceDiagnosticsApiActions } from './latest-device-diagnostics.actions';

function normalizeUdids(udids: string[]): string[] {
  return [...new Set(udids.map((udid) => udid.trim()).filter((udid) => udid.length > 0))];
}

@Injectable()
export class LatestDeviceDiagnosticsEffects {
  private readonly actions$ = inject(Actions);
  private readonly diagnosticsService = inject(DiagnosticsService);

  latestDeviceDiagnosticsRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LatestDeviceDiagnosticsActions.latestDeviceDiagnosticsRequested),
      map(({ udids }) => normalizeUdids(udids)),
      switchMap((udids) => {
        if (udids.length === 0) {
          return of(LatestDeviceDiagnosticsActions.latestDeviceDiagnosticsCleared());
        }

        return safeMap(
          this.diagnosticsService.queryLatestDeviceDiagnostics({ requestBody: udids }),
          (diagnostics) => LatestDeviceDiagnosticsApiActions.latestDeviceDiagnosticsLoaded({ diagnostics }),
          (error) => LatestDeviceDiagnosticsApiActions.latestDeviceDiagnosticsLoadedError({ error })
        );
      })
    );
  });
}
